import { Modal } from '@citizen-walk/shared-ui';

export interface PlaceholderFeatureModalProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

/** 「傾向表示」「一括再解析」等、未実装機能のボタンから開く説明モーダル (docs/25 Increment 2)。 */
export function PlaceholderFeatureModal({
  open,
  title,
  message,
  onClose,
}: PlaceholderFeatureModalProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <p className="text-sm text-slate-600">{message}</p>
    </Modal>
  );
}
